var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_769_2967",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_769_2967)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9993 17.2996L8.29933 20.1246C8.116 20.2746 7.916 20.3453 7.69933 20.3366C7.48266 20.3286 7.291 20.2663 7.12433 20.1496C6.95766 20.0329 6.82866 19.8746 6.73733 19.6746C6.64533 19.4746 6.641 19.2579 6.72433 19.0246L8.14933 14.3996L4.52433 11.8246C4.32433 11.6913 4.19933 11.5163 4.14933 11.2996C4.09933 11.0829 4.10766 10.8829 4.17433 10.6996C4.241 10.5163 4.35766 10.3536 4.52433 10.2116C4.691 10.0703 4.891 9.99961 5.12433 9.99961H9.59933L11.0493 5.19961C11.1327 4.96628 11.262 4.78694 11.4373 4.66161C11.612 4.53694 11.7993 4.47461 11.9993 4.47461C12.1993 4.47461 12.3867 4.53694 12.5613 4.66161C12.7367 4.78694 12.866 4.96628 12.9493 5.19961L14.3993 9.99961H18.8743C19.1077 9.99961 19.3077 10.0703 19.4743 10.2116C19.641 10.3536 19.7577 10.5163 19.8243 10.6996C19.891 10.8829 19.8993 11.0829 19.8493 11.2996C19.7993 11.5163 19.6743 11.6913 19.4743 11.8246L15.8493 14.3996L17.2743 19.0246C17.3577 19.2579 17.3537 19.4746 17.2623 19.6746C17.1703 19.8746 17.041 20.0329 16.8743 20.1496C16.7077 20.2663 16.516 20.3286 16.2993 20.3366C16.0827 20.3453 15.8827 20.2746 15.6993 20.1246L11.9993 17.2996Z",
    fill: "#DB578A"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.a3d43d47957b3f2984d1a5aa1642bbf8.svg";
export { ForwardRef as ReactComponent };